<div #container class="container flex" [class.flex-row]="!forceRowFlow" [class.flex-column]="forceRowFlow" [class.align-row]="shouldFlow">
  <div [class.left]="!forceRowFlow" [class.bottom]="forceRowFlow" [style]="bigStyle"><ng-content select="[big]"></ng-content></div>
  <div [class.right]="!forceRowFlow" [class.top]="forceRowFlow"><ng-content select="[small]"></ng-content></div>
</div>
